import { OPEN_QUERY_INFO } from 'action-types';

export default function () {
  return {
    type: OPEN_QUERY_INFO,
  };
}
